export default {

    // USAGE EXAMPLE
    /*
    file
        name: "indir.jpg"
        percentage: 0
        raw: File
            lastModified: 1588284141838
            lastModifiedDate: Fri May 01 2020 01:02:21 GMT+0300 (GMT+03:00) {}
            name: "indir.jpg"
            size: 4440
            type: "image/jpeg"
            uid: 1588288552916
            webkitRelativePath: ""
        __proto__: File
        size: 4440
        status: "ready"
        uid: 1588288552916
        url: "blob:http://localhost:3000/d659291d-c228-430d-a90d-385acb0aebea"    
     */
    /*
    resizeImage({
        // file: $image.files[0],
        file: file,
        maxSize: 1280
    }).then(function (resizedImage) {
        resizedImage.lastModifiedDate = new Date();
        resizedImage.name = fileName;
        console.log("upload resized image")
        self.onFileUpload(resizedImage, files)
    }).catch(function (err) {
        console.error(err);
    });
    */

    resizeImage (settings) {
        var file = settings.file;
        var maxSize = settings.maxSize;
        var reader = new FileReader();
        var image = new Image();
        var canvas = document.createElement('canvas');
        var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                atob(dataURI.split(',')[1]) :
                unescape(dataURI.split(',')[1]);
            var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++)
                ia[i] = bytes.charCodeAt(i);
            file.raw = new Blob([ia], { type: mime })
            return file;
        };
        var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL('image/jpeg');
            return dataURItoBlob(dataUrl);
        };
        return new Promise(function (ok, no) {
            if (!file.raw.type.match(/image.*/)) {
                no(new Error("Not an image"));
                return;
            }
            reader.onload = function (readerEvent) {
                image.onload = function () { return ok(resize()); };
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file.raw);
        });
    }
}